// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_fz","advertDetailContactGroup__header":"c-n_fA","advertDetailContactGroup__value":"c-n_fB"};